export enum ColumnAccessors {
  ReceivedDate = 'receivedDate',
  RecipientAccountUuid = 'recipientAccountUuid',
  SourceCompanyUuid = 'sourceCompanyUuid',
  TransactionType = 'transactionType',
  Amount = 'amount',
}
